import { render, staticRenderFns } from "./standardTableListdefind.vue?vue&type=template&id=56797c33&scoped=true"
import script from "./standardTableListdefind.vue?vue&type=script&lang=js"
export * from "./standardTableListdefind.vue?vue&type=script&lang=js"
import style0 from "./standardTableListdefind.vue?vue&type=style&index=0&id=56797c33&prod&lang=less&scoped=true"
import style1 from "./standardTableListdefind.vue?vue&type=style&index=1&id=56797c33&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56797c33",
  null
  
)

export default component.exports